import React from 'react';
import ExpressStore from '@/stores/express';
import Collapsiple from '@/common/collapsible';
import classNames from 'classnames';
import './index.less';

interface PropType {
  i18n: {
    [t: string]: string;
  };
  warehouseLeadTimeInfo: TradeTypes.WarehouseLeadTimeInfo;
  quantityUnitStr: string;
  semiHosted: boolean;
  coreCountry: boolean;
  preferedDispatchId: string;
  abtest: DetailTypes.Abtest;
}

export default function Index(props: PropType) {
  const {
    quantityUnitStr,
    coreCountry = false,
    i18n,
    warehouseLeadTimeInfo,
    semiHosted = false,
    abtest,
  } = props;

  if (!warehouseLeadTimeInfo) return null;
  if (semiHosted && coreCountry) return null;
  const { dispatchId } = ExpressStore((state) => state);

  const list = warehouseLeadTimeInfo[dispatchId] || warehouseLeadTimeInfo['DEFAULT'];
  if (Array.isArray(list)) {
    const lastItem = list.slice(-1);
    return (
      <div className="lead-layout">
        <Collapsiple
          title={i18n['undue_tpl_helpers.text_market_express_tit_lead_time']}
          abtest={abtest}
          logInfo="leadtime"
        >
          <div
            className={classNames({
              'lead-list': true,
            })}
          >
            <table>
              <tbody>
                <tr>
                  <td>{`${i18n['undue_market_action.quantity']} (${quantityUnitStr})`}</td>
                  {list.map((item, index) => (
                    <td key={index}>{`${item.minQuantity} - ${item.maxQuantity}`}</td>
                  ))}
                  <td> {`> ${lastItem[0].maxQuantity}`} </td>
                </tr>
                <tr>
                  <td>{i18n['detailModule.detailMarketPackage.EstTimeday']}</td>
                  {list.map((item, index) => (
                    <td key={index}>{item.processPeriod}</td>
                  ))}
                  <td>{i18n['rightAction.negotiated']}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Collapsiple>
      </div>
    );
  }
  return null;
}
